import router,{ findFirstValidRoute } from './router/index';
// import { usePermissionStoreWithOut } from './store/modules/permission';
// import { useUserStoreWithOut } from '@/store/modules/user';
import { useAppStoreWithOut } from '@/store/modules/app';
import { isEmpty } from './libs/utils';
import getPageTitle from './utils/web-title';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

NProgress.configure({ showSpinner: false });

const whiteList 	= ['/login'];
router.beforeEach(async(to, from, next) => {
	NProgress.start();
	// const users = useUserStoreWithOut();
	// const permission = usePermissionStoreWithOut();
	const appStore = useAppStoreWithOut();
	const siteData = await appStore.getData();
	getPageTitle(to.meta.title,siteData.title);

	next();
	// if(whiteList.includes(to.path)){
	// 	next();
	// }else if(!isEmpty(users.getToken())){
	// 	if(permission.getStatus()){
	// 		next();
	// 		return ;
	// 	}

	// 	await appStore.getWebSite();
	// 	await permission.getPurview();
	// 	const routes = permission.routes;
	// 	const firstPath = findFirstValidRoute(routes);
	// 	if(!firstPath){
	// 		next({ path: '/404' });
	// 		return ;
	// 	}
		
	// 	routes.forEach((route)=>{
	// 		router.addRoute("admin",route);
	// 	});
		
	// 	permission.setStatus(true);
	// 	next({ ...to, replace: true });
	// }else{
	// 	next(`/login?redirect=${to.path}`);
	// }
});

router.afterEach((to) => {
	NProgress.done();
});

router.onError(error=>{
	console.log("路由报错：",error);
	NProgress.done();
});